import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AgentLoSignupComponent } from './component/agent-lo-signup/agent-lo-signup.component';

const routes: Routes = [
  {
    path: '',
    component: AgentLoSignupComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AgentLoSignupRoutingModule {}
